import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { CheckCircle2, Loader2 } from "lucide-react";

export default function BillingReturn() {
  const { refresh } = useAuth();
  const nav = useNavigate();
  const [params] = useSearchParams();
  const [status, setStatus] = useState("checking"); // checking | active | pending | error

  useEffect(() => {
    let cancelled = false;
    let tries = 0;

    async function poll() {
      try {
        const r = await api.get("/billing/status");
        if (cancelled) return;
        if (r.data.active) {
          setStatus("active");
          await refresh();
          setTimeout(() => nav("/dashboard", { replace: true }), 1600);
          return;
        }
      } catch (e) { /* keep polling */ }
      tries += 1;
      if (tries < 10) {
        setTimeout(poll, 1500);
      } else {
        setStatus("pending");
      }
    }

    poll();
    return () => { cancelled = true; };
  }, [refresh, nav]);

  return (
    <div className="min-h-screen w-full flex items-center justify-center px-6">
      <div className="max-w-md w-full text-center">
        {status === "checking" && (
          <>
            <Loader2 className="h-10 w-10 mx-auto text-[#971a8c] animate-spin" />
            <h1 className="font-heading text-3xl mt-6 text-[#1C2321]">Setting up your trial…</h1>
            <p className="mt-3 text-[#5D6D63]">Stripe is finalizing your subscription. This usually takes a few seconds.</p>
          </>
        )}
        {status === "active" && (
          <>
            <CheckCircle2 className="h-12 w-12 mx-auto text-[#26abe2]" data-testid="billing-return-success" />
            <h1 className="font-heading text-3xl mt-6 text-[#1C2321]">You&apos;re in. Enjoy your 7 days.</h1>
            <p className="mt-3 text-[#5D6D63]">Redirecting you to the dashboard…</p>
          </>
        )}
        {status === "pending" && (
          <>
            <h1 className="font-heading text-3xl text-[#1C2321]">Almost there</h1>
            <p className="mt-3 text-[#5D6D63]">Your payment is still syncing. Refresh in a minute or head to your dashboard.</p>
            <div className="mt-6 flex gap-3 justify-center">
              <Link to="/dashboard" className="h-11 px-5 rounded-md bg-[#971a8c] text-white inline-flex items-center hover:bg-[#7d1574]">Go to dashboard</Link>
              <button onClick={() => window.location.reload()} className="h-11 px-5 rounded-md border border-[#E8E6DF] inline-flex items-center hover:bg-[#F3F1EC]">Refresh</button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
